import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import App from './App.tsx';
import { AppErrorBoundary } from './components/AppErrorBoundary';
import { injectCloudflareAnalytics } from './lib/cf-analytics';
import { initSentry } from './lib/sentry';
import './index.css';

initSentry();

// OCP-176 — Cloudflare Web Analytics beacon. No-op when
// VITE_CF_ANALYTICS_TOKEN env-var unset at build time.
injectCloudflareAnalytics();

// SPA-deploy chunk-load recovery: when an operator has a tab open
// during a deploy + the SPA tries to lazy-load a route chunk, the old
// hashed-filename URL 404s. Trap Vite's preload-error event + full
// reload. sessionStorage guard prevents infinite loops if the chunk
// is genuinely missing post-reload.
window.addEventListener('vite:preloadError', (event) => {
  event.preventDefault();
  const flag = 'orboto-admin-reload-on-preload-error';
  if (sessionStorage.getItem(flag)) return;
  sessionStorage.setItem(flag, '1');
  window.location.reload();
});

// OCP-331 — register the PWA service worker (Web Push + installable
// operator dashboard). Best-effort; failure just means no push.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {
      /* registration failed (unsupported / insecure context) — no push */
    });
  });
}

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('admin: #root element not found in index.html');

createRoot(rootEl).render(
  <StrictMode>
    <AppErrorBoundary>
      <App />
    </AppErrorBoundary>
  </StrictMode>,
);
